import React from 'react';
import { useMagnetic } from '../../hooks/useGsap';

/**
 * Wraps a button/anchor with a magnetic cursor effect.
 * Renders as the requested element via `as` prop.
 */
const MagneticButton = ({ as: Tag = 'a', strength = 0.25, className = '', children, ...rest }) => {
  const ref = useMagnetic(strength);
  return (
    <Tag ref={ref} className={className} {...rest}>
      {children}
    </Tag>
  );
};

export default MagneticButton;
